import { AndroidStudioIcon } from './AndroidStudioIcon';

/**
 * author: Google
 * id B156B15D-86F9-40E0-8B8E-421F78BE5509
 * name android-studio
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/android-studio.svg
 * tags
 * - Brand / Logo 
 */
export const MathCompassVariantIcon = AndroidStudioIcon;
export default MathCompassVariantIcon